import Box from '@mui/material/Box'

import { PageSection } from '../../../theme/components/PageSection'
import { Bijlagen } from '../components/Bijlagen'
import { Gegevens } from '../components/Gegevens'
import { useOpenKlantBijlage } from '../hooks/useOpenKlantBijlage'
import type { Klantgegevens } from '../types/Klantgegevens'

interface Props {
  id: string
  gegevens: Klantgegevens
}

export const Klant = ({ id, gegevens }: Props) => {
  const { mutate: openKlantbijlage } = useOpenKlantBijlage()

  const bijlagen = gegevens.bijlagen

  const onClick = (bijlageId) => openKlantbijlage({ id, bijlageId })

  return (
    <PageSection id="klantgegevens" heading="Klantgegevens">
      <Box>
        {gegevens && <Gegevens gegevens={gegevens} />}
        {bijlagen && <Bijlagen bijlagen={bijlagen} onClick={onClick} />}
      </Box>
    </PageSection>
  )
}
